import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import {
  SvgOne,
  SvgThree,
  SvgTwo,
} from "../../../../pages/authentication/components/login/components";

// Correctly type the styled component to accept custom props
const LoginRightPanel = styled(Box)<{ imageSrc?: string }>(
  ({ theme }) => `
  border: none;
  padding: 27% 12% 27% 20%;
  position: relative;
  z-index: 1;
  box-shadow: 0 4px 10px 0 rgba(7, 83, 70, 0.5);
  background: linear-gradient(103deg, #035344 47.79%, rgba(8, 118, 98, 0.90) 74.49%, #06584A 87.84%);
  background-size: cover;
  -webkit-backdrop-filter: blur(10px); /* For Safari support */
  border-radius: 60px 12px 12px 0px;
  overflow: hidden;
  height: 100%;

  & img {
    width: 50%;
    height: auto;
    justify-content: center;
    display: flex;
    margin: 0 auto;
    padding-bottom: 42px;
  }

  & svg {
    position: absolute;
  }

  & svg:nth-child(3) {
    top: 20%;
    right: 15%;
  }

  & svg:nth-child(4) {
    top: -1%;
    right: -1%;
    transform: scale(2);
  }

  & svg:nth-child(5) {
    bottom: -1%;
    right: -1%;
  }

  & .MuiTypography-root {
    color: #FFFFFF;
    font-weight: 300;
    font-size: 14px;
  }

  & .MuiTypography-h2 {
    color: #fafafa;
    font-weight: 500;
    text-align: center !important;
    font-size: 32px;
    padding-bottom: 32px;
  }

  & .MuiTypography-h5 {
    color: #fafafa;
    opacity: 0.75 !important;
    text-align: center !important;
    font-size: 14px;
    font-weight: 300;
    padding-bottom: 32px;
  }
`
);

// Define props interface
interface LoginRightPanelProps {
  imageSrc: string;
  title?: string;
  titleOpacity?: number; // New prop for title opacity
  subtitle?: string;
  text?: string;
}

// Functional component
const LoginRightPanelComponent: React.FC<LoginRightPanelProps> = ({
  imageSrc,
  title,
  titleOpacity = 1, // Default opacity is 1 (fully visible)
  subtitle,
  text,
}) => {
  return (
    <LoginRightPanel imageSrc={imageSrc}>
      {title && (
        <Typography
          variant="h2"
          sx={{ opacity: titleOpacity }} // Apply dynamic opacity
        >
          {title}
        </Typography>
      )}
      {subtitle && <Typography variant="h5">{subtitle}</Typography>}

      <img src={imageSrc} alt="Background" />

      <SvgOne />
      <SvgTwo />
      <SvgThree />

      {text && (
        <Typography
          variant="body1"
          sx={{ color: "#FFFFFF", marginTop: "20px" }}
        >
          {text}
        </Typography>
      )}
    </LoginRightPanel>
  );
};

export default LoginRightPanelComponent;
